import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import BaseTable from "../../components/table/BaseTable";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useLeads } from "../../services/leadsService";
import { LeadEditDialog } from "./LeadEditDialog";

export function ClientPassportLeadsTable(props) {
    const { t } = useTranslation();

    const HEADERS = [
        t("clients.ClientPassportLeadsTable.source"),
        t("clients.ClientPassportLeadsTable.seller"),
        t("clients.ClientPassportLeadsTable.date"),
        t("clients.ClientPassportLeadsTable.status"),
        t("clients.ClientPassportLeadsTable.investment"),
        t("clients.ClientPassportLeadsTable.product"),
        t("clients.ClientPassportLeadsTable.authorComment"),
        ...(props.disableEdit ? [] : [""]), // Column for edit button only if editing is enabled
    ];

    const { openDialog } = useDialogBetter();

    const searchParams = props.relatedLeadsForClientId 
        ? new URLSearchParams({
                related_leads_for_client_id: props.relatedLeadsForClientId,
            })
        : props.personId
            ? new URLSearchParams({ personId: props.personId })
            : new URLSearchParams({});

    if (props.investmentId) {
        searchParams.set("investment", props.investmentId);
    }

    const { data: leadsData, refetch, isLoading, isFetching } = useLeads(searchParams);

    const customerLeadsResponse = leadsData?.results
        ? leadsData.results.map((lead) => ({
              rowId: lead.id,
              originalData: lead, // Store the original lead data for edit
              data: [
                  lead.lead?.lead_source ? t(`lead.sources.${lead.lead.lead_source}`) : "-",
                  lead.lead?.lead_seller?.full_name || "-",
                  lead.lead?.created ? new Date(lead.lead.created).toLocaleString() : "-",
                  lead.lead?.lead_status ? t(`lead.status.${lead.lead.lead_status}`) : "-",
                  lead.lead?.investment?.investment_name_sales || "-",
                  lead.lead?.products?.map((product) => product.product_number).join(", "),
                  lead.lead?.lead_note_from_source || "-",
                  !props.disableEdit ? (
                      <IconButton
                          key={`edit-${lead.id}`}
                          size="small"
                          color="primary"
                          onClick={(e) => {
                              e.stopPropagation();
                              handleEditLead(lead);
                          }}
                      >
                          <EditIcon fontSize="small" />
                      </IconButton>
                  ) : null,
              ],
          }))
        : [];

    const handleEditLead = useCallback(
        (lead) => {
            openDialog({
                Component: LeadEditDialog,
                componentProps: { leadId: lead.id, lead: lead },
                onCloseFn: () => {
                    refetch();
                },
            });
        },
        [openDialog, refetch],
    );

    return (
        <Box sx={{ maxHeight: props.maxHeight || 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                showLoader={isFetching || isLoading}
                stickyHeader={true}
                headers={HEADERS}
                rows={customerLeadsResponse}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
                colMaxLength={props.colMaxLength}
            />
        </Box>
    );
}
